import { useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import GroupDetailsGeneralInformation from './GeneralInformation'
import GroupsDetailsGroup from './Groups'

import BackNavigation from '~/components/BackNavigation'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import Layout from '~/components/Layouts/Layout'
import MwMLoader from '~/components/MwMLoader'
import ViewTitle from '~/components/ViewTitle'
import { useGroupDetailsQuery } from '~/queries/user-groups'

const GroupDetails = (): ReactElement | null => {
  const { groupId } = useParams<{ groupId: string }>()

  const { data: group, isLoading } = useGroupDetailsQuery(groupId)

  if (isLoading) {
    return (
      <Layout>
        <MwMLoader category="item" />
      </Layout>
    )
  }

  if (!group) {
    return null
  }

  const { description, group_name, id, updated_at_ts, updated_by } = group

  const updatedBy = {
    date: updated_at_ts,
    name: updated_by.first_name,
    picture: updated_by.picture,
  }

  return (
    <Layout>
      <ViewTitle className="flex justify-space-between">
        <BackNavigation title="Groups" to="/mwm-users/groups" />
        <div className="flex align-center justify-center">Group detail</div>
        <LastUpdatedByCard updatedBy={updatedBy} />
      </ViewTitle>
      <GroupDetailsGeneralInformation description={description} id={id} name={group_name} />
      <GroupsDetailsGroup group={group} />
    </Layout>
  )
}

export default GroupDetails
